import { SVGProps } from 'react';

const GraduationCapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_700_809)">
      <path
        d="M12.5 1.25C12.1836 1.25 11.8711 1.30469 11.5742 1.41016L0.617178 5.36719C0.246085 5.50391 -9.09099e-06 5.85547 -9.09099e-06 6.25C-9.09099e-06 6.64453 0.246085 6.99609 0.617178 7.13281L2.8789 7.94922C2.23827 8.95703 1.87499 10.1484 1.87499 11.4023V12.5C1.87499 13.6094 1.45312 14.7539 1.0039 15.6562C0.749991 16.1641 0.460928 16.6641 0.124991 17.125C-9.08971e-06 17.293 -0.0351653 17.5117 0.0351472 17.7109C0.10546 17.9102 0.269522 18.0586 0.472647 18.1094L2.97265 18.7344C3.13671 18.7773 3.31249 18.7461 3.45702 18.6562C3.60155 18.5664 3.70312 18.418 3.73437 18.25C4.0703 16.5781 3.90233 15.0781 3.65233 14.0039C3.52733 13.4492 3.35937 12.8828 3.12499 12.3633V11.4023C3.12499 10.2227 3.52343 9.10937 4.21483 8.21875C4.71874 7.61328 5.37109 7.125 6.13671 6.82422L12.2695 4.41406C12.5898 4.28906 12.9531 4.44531 13.0781 4.76562C13.2031 5.08594 13.0469 5.44922 12.7266 5.57422L6.59374 7.98438C6.10937 8.17578 5.68359 8.46875 5.33593 8.82812L11.5703 11.0781C11.8672 11.1836 12.1797 11.2383 12.4961 11.2383C12.8125 11.2383 13.125 11.1836 13.4219 11.0781L24.3828 7.13281C24.7539 7 25 6.64453 25 6.25C25 5.85547 24.7539 5.50391 24.3828 5.36719L13.4258 1.41016C13.1289 1.30469 12.8164 1.25 12.5 1.25ZM4.99999 15.9375C4.99999 17.3164 8.35937 18.75 12.5 18.75C16.6406 18.75 20 17.3164 20 15.9375L19.4023 10.2578L13.8476 12.2656C13.4141 12.4219 12.957 12.5 12.5 12.5C12.043 12.5 11.582 12.4219 11.1523 12.2656L5.59765 10.2578L4.99999 15.9375Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_700_809">
        <path d="M0 0H25V20H0V0Z" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export default GraduationCapIcon;
